import React, { Component } from 'react'
import ContentLoader from 'react-content-loader'

export default class ConfigLoader extends Component {
  render() {
    return (
      <ContentLoader primaryColor="#f3f3f3" secondaryColor="#ecebeb">
        <rect x={0} y={0} rx="1" ry="1" width={25} height={8} />
        <rect x={30} y={0} rx="1" ry="1" width={25} height={8} />
        <rect x={60} y={0} rx="1" ry="1" width={25} height={8} />
        <rect x={90} y={0} rx="1" ry="1" width={25} height={8} />
        <rect x={120} y={0} rx="1" ry="1" width={25} height={8} />
        <rect x={150} y={0} rx="1" ry="1" width={25} height={8} />
        <rect x={180} y={0} rx="1" ry="1" width={25} height={8} />
        <rect x={210} y={0} rx="1" ry="1" width={25} height={8} />
        <rect x={240} y={0} rx="1" ry="1" width={25} height={8} />

        <rect x={0} y={20} rx="1" ry="1" width={400} height={30} />

        <rect x={0} y={60} rx="1" ry="1" width={80} height={8} />
        <rect x={120} y={60} rx="1" ry="1" width={250} height={8} />

        <rect x={0} y={80} rx="1" ry="1" width={80} height={8} />
        <rect x={120} y={80} rx="1" ry="1" width={250} height={8} />

        <rect x={0} y={100} rx="1" ry="1" width={80} height={30} />

        <rect x={120} y={100} rx="1" ry="1" width={250} height={8} />
        <rect x={120} y={120} rx="1" ry="1" width={250} height={8} />

      </ContentLoader>
    )
  }
}
